<template>
<div class="chapter">
<div class="inner_page">
<p class="p3"><span class="sz"> </span></p>
<p class="p3"><span class="sz"> </span></p>
<p class="p4"><span class="sz"><b>Adjusted Planck Units – Time</b></span></p>
<p class="p3"><span class="sz"><b></b> </span></p>
<p class="p4"><span class="sz"><b>Old Seconds</b></span></p>
<p class="p3"><span class="sz"> </span></p>
<div style="text-align:center"><img alt="Echoes-of-Earth-Diagram-One" src="images/Echoes-of-Earth-Diagram-One.png"/></div>
<p class="p3"><span class="sz"> </span></p>
<p class="p4"><span class="sz">NB: For more information about Planck Units, see Appendix 1.</span></p>
<p class="p3"><span class="sz"> </span></p>
<p class="p3"><span class="sz"> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section4.vue?7a34703c